const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;
const _require2 = require('../lib/environmental'),
  celsiusFromFahrenheit = _require2.celsiusFromFahrenheit,
  relativeHumidity = _require2.relativeHumidity;

/**
  * @function evalute - evaluate relativeHumidityBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const dryBulbFahrenheit = await evaluateSource(source.dryBulbSource, content, parentContentPath, transientContext, nativeFunctions);
  if (Number.isNaN(Number(dryBulbFahrenheit))) {
    return undefined;
  }
  const dryBulbCelsius = celsiusFromFahrenheit(dryBulbFahrenheit);
  const wetBulbFahrenheit = await evaluateSource(source.wetBulbSource, content, parentContentPath, transientContext, nativeFunctions);
  if (Number.isNaN(Number(wetBulbFahrenheit))) {
    return undefined;
  }
  const wetBulbCelsius = celsiusFromFahrenheit(wetBulbFahrenheit);
  return relativeHumidity(dryBulbCelsius, wetBulbCelsius);
};
module.exports = {
  evaluate
};